module.exports = __webpack_public_path__ + "img/middle_point.060ced7c.png";